// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderInformationStyles } from "@awc/Overrides/Widgets/OrderConfirmation/OrderConfirmationOrderInformation";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const subSectionTitle: TypographyPresentationProps = {
    variant: "h3",
    css: css`
        margin-bottom: 12px;
        @media print {
            font-size: ${fontConfig.fontSize.link}px;
        }
    `,
};
orderInformationStyles.OrderInformationGridContainer = {
    gap: 24,
};
orderInformationStyles.orderInformationGridItem = {
    width: [12, 12, 12, 6, 6],
};
orderInformationStyles.createAccountGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        &:empty {
            display: none;
        }
    `,
};
orderInformationStyles.shippingAndBillingGridItem = {
    width: 12,
    css: css``,
};
orderInformationStyles.billingInformationGridItem = {
    width: [12, 12, 12, 4, 4],
};
orderInformationStyles.shippingInformationGridItem = {
    width: [12, 12, 12, 4, 4],
};
orderInformationStyles.shippingOtherInformationGridItem = {
    width: [12, 12, 12, 4, 4],
};
orderInformationStyles.vatNumberGridItem = {
    width: [12, 12, 12, 4, 4],
};
orderInformationStyles.shippingInformationCarrierGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.shippingInformationDateRequestedGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.billingInformationCreditCardAddressGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
orderInformationStyles.shippingTitle = {
    ...subSectionTitle,
    ...{ as: "h2" },
};
orderInformationStyles.billingCreditCardAddressTitle = {
    ...subSectionTitle,
};
orderInformationStyles.billingInformationCreditCardAddressTitle = {
    ...subSectionTitle,
};
orderInformationStyles.dateRequestedTitle = {
    ...subSectionTitle,
};
orderInformationStyles.vatNumberTitleText = {
    ...subSectionTitle,
};
orderInformationStyles.notesTitle = {
    ...subSectionTitle,
};
orderInformationStyles.notesDescription = {
    size: fontConfig.fontSize.regular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
};
orderInformationStyles.orderConfirmationShippingInformation = {
    shippingInformationAddressGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    shippingAddressTitle: {
        ...subSectionTitle,
        ...{ as: "h2" },
    },
};

orderInformationStyles.orderConfirmationBillingInformation = {
    billingInformationBillingAddressGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
            @media print {
                width: 100%;
            }
        `,
    },
    billingAddressTitle: {
        ...subSectionTitle,
        ...{ as: "h2" },
    },
};

orderInformationStyles.orderNumberGridItem = {
    width: 12,
};
orderInformationStyles.statusGridItem = {
    width: 12,
};
orderInformationStyles.orderDateGridItem = {
    width: 12,
};
orderInformationStyles.poNumberGridItem = {
    width: 12,
};
orderInformationStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    heading: {
        variant: "h2",
        css: css`
            @media print {
                font-size: ${fontConfig.fontSize.sectionTitle}px;
                line-height: ${fontConfig.lineHeight.headLineMobile};
                display: inline-block;
            }
            margin-bottom: 0;
            &:after {
                content: ":";
                margin-right: 4px;
            }
        `,
    },
    text: {
        variant: "h2",
        css: css`
            width: auto;
            @media print {
                font-size: ${fontConfig.fontSize.sectionTitle}px;
                line-height: ${fontConfig.lineHeight.headLineMobile};
                display: inline-block;
            }
            margin-bottom: 0;
        `,
    },
};
orderInformationStyles.shippingAccountNum = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    heading: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.singleLineRegular,
        weight: fontConfig.weight.bold,
        transform: "capitalize",
        css: css`
            @media print {
                display: inline-block;
            }
            &:after {
                content: ":";
                margin-right: 4px;
            }
        `,
    },
    text: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.singleLineRegular,
        css: css`
            width: auto;
            @media print {
                font-size: ${fontConfig.fontSize.small}px;
            }
        `,
    },
};
